
import { Component,Prop, BaseMixins,Watch,domHelper } from '@/lib';
@Component({name:"section-button"})
export default class SectionButton extends BaseMixins{
    /*不显示导出按钮*/
    @Prop({type:Boolean, default:false}) exportEnabled:boolean;
    /*导出dispatch type*/
    @Prop({type:String}) exportAction:string;

    @Prop({type:String,}) exportApi:string;

    /*查询model*/
    @Prop({type:Object}) exportModel:any;
    /*导出按钮大小*/
    @Prop({type:String}) exportButtonSize:string;

    get exportClass(){
        if(this.exportEnabled){
            if(this.$slots.default && this.$slots.default.length > 0){
                return "toolbar-btn";
            }
        }
        return "";
    }

    /**
     * excel导出并下载
     */
    async exportExcel(url) {
        //若不指定，则使用默认的文件下载Store的Action进行统一处理。
        if(!this.exportAction){
            let response = await this.$store.dispatch({
                type: "system/attachment/exportExcel",
                data: { url: this.exportApi, pageRequest: this.exportModel }
            });
            let name = response.headers["content-disposition"].split("=")[1];

            domHelper.downloadFile(response.data, decodeURI(name));
        } else{
            let response = await this.$store.dispatch({
                type: this.exportAction,
                data: { pageRequest: this.exportModel }
            });
            let name = response.headers["content-disposition"].split("=")[1];

            domHelper.downloadFile(response.data, decodeURI(name));
        }
        
    }
}
